import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getCurrentLanguage } from '@/i18next'
import styles from './TableSign.module.scss'
import { headCells } from './table.headings'
import { Dots, Success } from '@app/icons'

const TableSign = ({ currentEtd, title }) => {
	const { t } = useTranslation()
	const lang = getCurrentLanguage()

	const {
		signEmployeeDate,
		consentDate,
		signEmployerDate,
		signRepresentativeDate,
		under16,
		iin,
		fullName,
		bin,
		employerName,
		representativeIin,
		representativeName,
	} = currentEtd

	const statusEmployee = {
		nameRu: signEmployeeDate ? 'Подписан' : 'Ожидает подписи',
		nameKz: signEmployeeDate ? 'Қол қойылған' : 'Қолын күтуде',
	}

	const statusEmployeeTeenager = {
		nameRu: consentDate ? 'Согласовано' : 'Ожидает согласования',
		nameKz: consentDate ? 'Келісілді' : 'Келісуді күтуде',
	}

	const statusEmployer = {
		nameRu: signEmployerDate ? 'Подписан' : 'Ожидает подписи',
		nameKz: signEmployerDate ? 'Қол қойылған' : 'Қолын күтуде',
	}

	const statusRepresentative = {
		nameRu: signRepresentativeDate ? 'Подписан' : 'Ожидает подписи',
		nameKz: signRepresentativeDate ? 'Қол қойылған' : 'Қолын күтуде',
	}

	const tableHeader = useMemo(
		() => (
			<>
				{headCells.map((head, index) => (
					<th key={index + 'thead-th'}>{t(head.label)}</th>
				))}
			</>
		),
		[t]
	)

	return (
		<>
			<div className={styles.status__title}>{title}</div>
			<table className={styles.table}>
				<thead>
					<tr>{tableHeader}</tr>
				</thead>
				<tbody>
					{under16 ? (
						<tr>
							<td>{t('employee')}</td>
							<td>{iin || '-'}</td>
							<td>{fullName || '-'}</td>
							<td>{consentDate || '-'}</td>
							<td>
								{consentDate ? <Success className={styles.iconSuccess} /> : <Dots className={styles.iconClock} />}
								<span className={consentDate ? styles.textSuccess : styles.textClock}>
									{lang === 'rus' ? statusEmployeeTeenager.nameRu : statusEmployeeTeenager.nameKz}
								</span>
							</td>
						</tr>
					) : (
						<tr>
							<td>{t('employee')}</td>
							<td>{iin || '-'}</td>
							<td>{fullName || '-'}</td>
							<td>{signEmployeeDate || '-'}</td>
							<td>
								{signEmployeeDate ? <Success className={styles.iconSuccess} /> : <Dots className={styles.iconClock} />}
								<span className={signEmployeeDate ? styles.textSuccess : styles.textClock}>
									{lang === 'rus' ? statusEmployee.nameRu : statusEmployee.nameKz}
								</span>
							</td>
						</tr>
					)}
					<tr>
						<td>{t('employer')}</td>
						<td>{bin || '-'}</td>
						<td>{employerName || '-'}</td>
						<td>{signEmployerDate || '-'}</td>
						<td>
							{signEmployerDate ? <Success className={styles.iconSuccess} /> : <Dots className={styles.iconClock} />}
							<span className={signEmployerDate ? styles.textSuccess : styles.textClock}>
								{lang === 'rus' ? statusEmployer.nameRu : statusEmployer.nameKz}
							</span>
						</td>
					</tr>
					{representativeIin && representativeIin?.length > 0 ? (
						<tr>
							<td>{t('representative_role')}</td>
							<td>{representativeIin || '-'}</td>
							<td>{representativeName || '-'}</td>
							<td>{signRepresentativeDate || '-'}</td>
							<td>
								{signRepresentativeDate ? (
									<Success className={styles.iconSuccess} />
								) : (
									<Dots className={styles.iconClock} />
								)}
								<span className={signRepresentativeDate ? styles.textSuccess : styles.textClock}>
									{lang === 'rus' ? statusRepresentative.nameRu : statusRepresentative.nameKz}
								</span>
							</td>
						</tr>
					) : null}
				</tbody>
			</table>
		</>
	)
}

export default TableSign
